import React from "react";
import { Box, Spinner } from "@chakra-ui/react";
import shallow from "zustand/shallow";
import { useSelectedClassroomStore } from "@/stores/v2/selectedClassroomStore";
import { useClassroomSessionStore } from "@/stores/v2/classroomSessionStore";
import IconPencil from "@/js/components/svgr/IconPencil.js";

interface Props {
	children: React.ReactNode;
	blue: boolean;
	isMonitoringClass: boolean;
	classroomName: string;
	classExpiryStr: string;
	screenView: boolean;
	classroomId: string;
}

const EditClassButton = (props: Props): JSX.Element => {
	const selectedClassroomStore = useSelectedClassroomStore(
		(state) => ({
			setData: state.setData,
		}),
		shallow
	);

	const handleClick = (ev: React.MouseEvent) => {
		ev.stopPropagation();
		//@ts-expect-error - Leaving as is to reduce refactoring in current change
		selectedClassroomStore.setData({ id: props.classroomId });
		useClassroomSessionStore.getState().handleShowEditClassModal({
			show: true,
			classroomName: props.classroomName,
			classExpiryStr: props.classExpiryStr,
			monitoring: props.isMonitoringClass,
		});
	};

	const getPencilColor = () => {
		if (props.blue) {
			return "Classroom_editButtonIcon--blue";
		}
		return "Classroom_editButtonIcon--normal";
	};

	const getButtonClass = () => {
		if (props.screenView) {
			return "ctxbar--Classroom_editButton";
		}
		if (props.isMonitoringClass === true) {
			return "Classroom_editButton Monitoring_pill";
		}
		return "Classroom_editButton";
	};

	return (
		<Box as="button" className={getButtonClass()} onClick={handleClick} aria-label="Edit class session" data-testid="edit-class-button">
			<span className={`Classroom_editButtonLabel${props.blue ? "--blue" : ""}`}>
				{props.children}
				{props.classExpiryStr ? (
					<IconPencil className={getPencilColor()} />
				) : (
					<div>
						<Spinner color="white" width={"12px"} height={"12px"} />
					</div>
				)}
			</span>
		</Box>
	);
};

export default EditClassButton;
